import React from 'react';
import { Modal } from '../_components';
import { useModal } from '../_contexts';
import { EventListForm } from './forms';

export function EventManager() {
  const { closeModal } = useModal();

  return (
    <Modal
      id="eventManagerModal"
      // backdrop
      title="Events Manager"
      icon="far fa-sparkles fa-fw"
      size="md"
      open
      onClose={() => closeModal()}
    >
      <EventListForm />
    </Modal>
  );
}
